// src/constants/inboxTags.js
export const assetInboxTags = {
    //User Inbox
  0: [
    "boreq_back_user_mod",
    "bo_return_to_user_mod",
    "uhreq_paraprvd_forstore",
    "uhreq_paraprvd_forclose",
    "uhreq_allbolvlaprvd_forclose",
    "new_bo_transfer_req",
    "lvl2req_apprvd_foraccptnce",
    "uh_apprvd_bo_user_transfer"
  ],
//BO Inbox
  1: [
    "ureq_created",
    "uhreq_bolvl_rtrned_mod",
    "ureq_resubmit_modified",
    "user_resubmit_return",
    "ureq_rtrn_asst_created",
    "unithead_return_to_bo",
    "bo_user_transfer_rejected_by_unithead"
  ],
//Unit Head Inbox
  2: [
    "boreq_issueallclose_forapprv",
    "boreq_parissue_forapprv",
    "boreq_parissueclse_forapprv",
    "bo_forwarded_to_unithead",
    "boreq_fwd_unithead",
    "bo_store_return_created",
    "bo_user_transfer_unithead_approval",
  ],
  //Asset Manager-I Inbox
  3: [
    "uhreq_fwded_store",
    "ureq_paraccept_fwdstore",
    "bo_forwarded_to_store",
    "unithead_forwarded_to_store",
    "ureq_retrn_ind_store_created",
    "botostore_return_req_forwarded",
    "lvl2req_back_formodific",
    "cosumureq_created",
  ],
  //Asset Manager-II Inbox
  4: [
    "lvl1req_fwd_selected_assets",
    "lvl1req_rejectn_forappvl"
  ],
  //Closed
  5: [
    "boreq_rejct_closed",
    "ureq_storeassetsaccpt_close",
    "ureq_assets_rejected",
    "ureq_allasstbolvl_close",
    "ureq_paraccept_close",
    "store_return_approved",
    "bo_return_req_approved",
    "ureq_storeassetsaccpt_close",
    "bo_return_req_approved",
    "store_return_approved",
    "botouser_transfer_accepted"
  ]
};
